import { render, staticRenderFns } from "./ReportbedtagBalance.vue?vue&type=template&id=24528f8a&scoped=true&"
import script from "./ReportbedtagBalance.vue?vue&type=script&lang=js&"
export * from "./ReportbedtagBalance.vue?vue&type=script&lang=js&"
import style0 from "./ReportbedtagBalance.vue?vue&type=style&index=0&id=24528f8a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24528f8a",
  null
  
)

export default component.exports